// classe de stockage des énumérés (constantes)

// normalisation des noms de panneaux latéraux
export enum SIDE_PANEL_NAME {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

// mode de connexion remote : ON / OFF
export enum REMOTE_CNX_MODE {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
}

// constantes d'events
export enum ALK_EVENT_TYPE {
  ADD = 'ALK_EVENT_ADD',
  DELETE = 'ALK_EVENT_DELETE',
  EDIT = 'ALK_EVENT_EDIT',
  NODE_SELECT = 'ALK_EVENT_NODE_SELECT',
  UPDATE_MODEL = 'UPDATE_MODEL',
  SET_LOCALE = 'SET_LOCALE', // application de la langue en cours
  VALIDATE = 'ALK_EVENT_VALIDATE',
  DATA_CHANGE = 'ALK_EVENT_DATA_CHANGE',
  ITEM_SELECTED = 'ALK_EVENT_ITEM_SELECTED', // sélection d'un élement dans le tableau de gauche la vue
  USER_LOADED = 'USER_LOADED', // chargement du user effectif (et complet)
  TAB_COLLECTION_CHANGE = 'TAB_COLLECTION_CHANGE', // modification de la collection de tabs (add / delete / rename)
  BU_SWAP_CONFIRM = 'BU_SWAP_CONFIRM', // confirmer la perte de donnée sur changement sans valider
  BU_SWAP_CANCEL = 'BU_SWAP_CANCEL', // cancel sur changement de BU
  BU_DELETE = 'BU_DELETE', // demande de suppression d'une BU
  COLUMNS_CHANGE = 'COLUMNS_CHANGE', // modification du pools de colonnes d'un grid
  GRID_REFRESHED = 'GRID_REFRESHED', // évenement de rafraichissement d'une grille
  ADD_EM = 'AD_EM', // persistence d'un EM
  REMOVE_EM = 'AD_EM', // retour de rollback sur un EM
  CHRONO_CREATE = 'CHRONO_CREATE', // Création de chronocodes
  CHRONO_DELETE = 'CHRONO_DELETE', // Suppression d'arbre de chronocodes
  CHRONO_LEVEL_ACTIVATE = 'CHRONO_LEVEL_ACTIVATE', // Activation d'un niveau de chronocode en création
  CHRONO_LEVEL_DEACTIVATE = 'CHRONO_LEVEL_DEACTIVATE', // Desactivation d'un niveau de chronocode en création
  CHRONO_DATE_CHANGE = 'CHRONO_DATE_CHANGE', // Changement de date de chronocode
  CHRONO_TIMEGAP_CHANGE = 'CHRONO_TIMEGAP_CHANGE', // Changement de date de chronocode
  CHRONO_LABEL_CHANGE = 'CHRONO_LABEL_CHANGE', // Changement de libellé d'un chronocode
  FEI_SET = 'FEI_SET', // la datasource (FEI) a été définie pour un widget, contient FEI
  FEI_COMPUTED = 'FEI_COMPUTED', // calcul initial sur un FEI, contient FEI
  FEI_RECOMPUTED = 'FEI_RECOMPUTED', // recalcul d'un FEI, contient une map de <fei, LooResult> d'éléments ajoutés, supprimés, modifiés
  WIDGET_READY = 'WIDGET_READY', // signale que le widget est OK, pour éventuel calcul des slaves data = Iwidget
  // WIDGET_UPDATE_SELECTION = 'WIDGET_UPDATE_SELECTION', // modification du pool de sélection pour un widget data = IWidget
  GLOBAL_FILTER_READY = 'GLOBAL_FILTER_READY', // un widget de type global filter est OK data = fei
  WIDGET_UPDATED = 'WIDGET_UPDATED', // signale une modification structurelle du widget, pour mise à jour éventuelle des slaves data = widget
  GLOBAL_FILTER_UPDATED = 'GLOBAL_FILTER_UPDATED', // signale une modification structurelle du globalFilter data = widget

  INNER_FILTER_UPDATE = 'INNER_FILTER_UPDATE', // signale la mise à jour d'un filtre pour son widget parent data = iWidgetFilter
  DELETE_SCENARIO = 'DELETE_SCENARIO', // suppression d'un scenario depuis la popUp scenar des widgets data = scenarioVO[]
  FEI_UPDATED = 'FEI_UPDATED', // retour de service d'update sur pivot, contient CommitMap
  ROLLBACK = 'ROLLBACK', // demande de rollback sur un EM
  APP_SETTINGS = 'APP_SETTINGS', // Paramétrage d'une application
  APP_DUPLICATE = 'APP_DUPLICATE', // Duplication d'une application
  NAVIGATE_TO = 'NAVIGATE_TO', // demande de navigation vers une autre vue
  APP_PLAY = 'APP_PLAY', // Lancement d'une application
  LOGOUT = 'LOGOUT', // Demande de déconnexion
  MEASURE_SET_MODE = 'MEASURE_SET_MODE', // changement de mode de vision des measures
  MEASURE_DEPENDENCY = 'MEASURE_DEPENDENCY', // afficher les measures nécessaires pour le calcul de cette mesure
  MEASURE_LEGACY = 'MEASURE_LEGACY', // afficher les mesures qui héritent de cette mesure
  MEASURE_SELECT = 'MEASURE_SELECT', // sélection d'une mesure depuis le graph
  MEASURE_QUICK_SELECT = 'MEASURE_QUICK_SELECT', // 2x clic sur une mesure pour ajout depuis l'éditeur
  MEASURE_SHOW_HIDE = 'MEASURE_SHOW_HIDE', // suppression d'une mesure depuis le graph / ajout d'une mesure depuis le tree
  MEASURE_RECOMPUTE = 'MEASURE_RECOMPUTE', // sur modification d'une formule, recalcul de la matrice
  MEASURE_DELETE = 'MEASURE_DELETE', // suppression d'un override de step pour une mesure
  MEASURE_SHOW_FORMULA_EDITOR = 'MEASURE_SHOW_FORMULA_EDITOR', // édition directe de la formule depuis la matrice
  DUPLICATE_DATA = 'DUPLICATE_DATA', // demande de duplication d'une donnée (ex: chronocode)
  KEY_STEP_UP = 'KEY_STEP_UP', // monter une clé vers le step supérieur (et toutes ses précédentes)
  KEY_STEP_DOWN = 'KEY_STEP_DOWN', // descendre une clé vers le step inférieur (et toutes ses suivantes)
  // PIVOT_SET_FILTER = 'PIVOT_SET_FILTER', // modification du filtre sur un pivot
  PIVOT_CONFIGURE_FIELD = 'PIVOT_CONFIGURE_FIELD', // affichage de la subpop de configuration des champs de pivot
  PIVOT_CONFIGURE_GROUP_FIELD = 'PIVOT_CONFIGURE_GROUP_FIELD', // affichage de la subpop de configuration d'un groupe de colonnes
  SELECT_BU = 'SELECT_BU', // signaler la sélection d'une BU pour rafraichir le breadCrumb
  SELECT_VISION = 'SELECT_VISION', // signaler le changement de vision pour rafraichir le breadCrumb
  SELECT_VISION_FROM_GUARD = 'SELECT_VISION_FROM_GUARD', // signaler le changement de vision. Aucun refresh de modèle autorisé suite à cet event
  FEED_VISIONS = 'FEED_VISIONS', // signale que les visions de la BU sont chargée (visionManager) pour alimentation Menu & Info
  CREATE_BASELINE = 'CREATE_BASELINE', // ajout d'une nouvelle baseline depuis le formulaire, data = [fei, Baseline]
  REMOVE_BASELINE = 'REMOVE_BASELINE', // suppression d'une baseline, data = [fei, Baseline]
  SET_TAB_POOL = 'SET_TAB_POOL', // modification du jeu d'onglets
  REMOVE_TAB = 'REMOVE_TAB', // sur suppression d'un Tab, pour signaler au User_tab_view qu'il doit se rafraichir
  DELETE_TAB = 'DELETE_TAB', // suppression physique d'un tab
  DELETE_CHRONO_TEMPLATE_ITEM = 'DELETE_CHRONO_TEMPLATE_ITEM', // demande de suppression d'un chrono undefined pour un level
  UPDATE_CHRONO_TEMPLATE_ITEM = 'UPDATE_CHRONO_TEMPLATE_ITEM', // demande de mise à jour des enfants chrono d'un level
  INC_EXC_ADD_PART = 'INC_EXC_ADD_PART', // ajout d'un élément de clé sur une inc/ exc key
  INC_EXC_DEL_PART = 'INC_EXC_DEL_PART', // suppression d'un élément de clé sur une inc / exc key
  INC_EXC_DEL_KEY = 'INC_EXC_DEL_KEY', // suppression d'une inc / exc key
  INC_EXC_FAST_INC = 'INC_EXC_FAST_INC', // génération d'une clé complète depuis le sample
  INC_EXC_FAST_EXC = 'INC_EXC_FAST_EXC', // génération d'une clé complète (exclude) depuis le sample
  INC_EXC_UPDATE_SAMPLE = 'INC_EXC_UPDATE_SAMPLE', // signale un changement de clé INC/EXC, l'ajout ou la suppression de part pour refresh du sample
  FORM_UPDATE = 'FORM_UPDATE', // une modification sur un champ (hors drops) du formulaire, data = FormUpdate
  FORM_KEY = 'FORM_KEY', // une modification sur un champ (numeric ou date) pour affichage save / cancel
  FORM_SAVED = 'FORM_SAVED', // fin de save dans un form. Contient un DataPack
  FORM_CANCELED = 'FORM_CANCELED', // cancel des modifs sur un form (pour hide de la pop du calendar)
  FORM_ZONE_UPDATE = 'FORM_ZONE_UPDATE', // ouverture / fermeture d'une zone accordéon sur le form
  FORM_ZONE_APPLY = 'FORM_ZONE_APPLY', // ordre d'ouverture / fermeture sur les args
  ADD_MEASURE = 'ADD_MEASURE', // ajout d'une mesure à la vision en cours
  REMOVE_MEASURE = 'REMOVE_MEASURE', // suppression d'une mesure de la vision en cours
  STYLE_STEP_UP = 'STYLE_STEP_UP', // monter une clé vers le step supérieur
  STYLE_STEP_DOWN = 'STYLE_STEP_DOWN', // descendre une clé vers le step inférieur
  STYLE_STEP_DELETE = 'STYLE_STEP_DELETE', // suppression d'une condition
  STYLE_ELEMENT_CHANGED = 'STYLE_ELEMENT_CHANGED', // modification du contenu d'une ligne de condition de style, pour maj du styleVO
  WIDGET_SET_SETTINGS = 'WIDGET_SET_SETTINGS', // retour de popUp de configuration d'un widget
  WIDGET_SET_DATAS = 'WIDGET_SET_DATAS', // retour de chargement des données du widget
  WIDGET_RESIZE = 'WIDGET_RESIZE', // redimensionnement dans gridster du templating
  WIDGET_CHANGE_SEQUENCE = 'WIDGET_CHANGE_SEQUENCE', // suppression d'un widget, recalcul de leur indice
  CHART_UPDATE_PARAMETER = 'CHART_UPDATE_PARAMETER', // mise à jour des paramètres d'un chart (manuel)
  DELETE_CALENDAR_EVENT = 'DELETE_CALENDAR_EVENT', // demande de suppression d'un event de calendar
  EDIT_CALENDAR_EVENT = 'EDIT_CALENDAR_EVENT', // édition d'une entrée de calendar
  UPDATE_CALENDAR_EVENT = 'UPDATE_CALENDAR_EVENT', // modif sur entrée de calendar, refresh
  PIVOT_DATA_UPDATE = 'PIVOT_DATA_UPDATE', // mise à jour des données du grid
  FREEDATA_WILD_ADDED = 'FREEDATA_WILD_ADDED', // ajout d'un freedata libre, pour synchro des autres formulaires
  CHECK_SLAVE_INTEGRITY = 'CHECK_SLAVE_INTEGRITY', // sur changement du pool de datas d'un widget, contrôle de l'intégrité par la vue templating
  RESET_MASTER = 'RESET_MASTER', // event pour remise à 0 d'un master inconséquent
  // MASTER_POOL_SELECT = 'MASTER_POOL_SELECT', // modification du pool de sélection d'un master
  VSP_SELECT_CHANGED = 'VSP_SELECT_CHANGED', // change de la portée de sélection dans un stepPerimeter
  BATCH_IMPORT_RETURN = 'BATCH_IMPORT_RETURN', // retour de batch d'import, pour synchro de la vue
  FREEDATA_UPDATED = 'FREEDATA_UPDATED', // update d'un FDV dans les widgets, value = Map<string, FreedataUpdatePack>
  UPDATE_FD_FIELD = 'UPDATE_FD_FIELD', // modification d'un champ de freeData dans le form, pour synchro des fields de même FD
  FORM_REFRESH_FIELDS = 'FORM_REFRESH_FIELDS', // fin de contrôle d'intégrité sur le formulaire, mise à jour éventuelle des champs. data = Map<string, string>
  FORM_REFRESH_ERRORS = 'FORM_REFRESH_ERRORS', // refresh des argRenderers sur erreur
  FORM_SUB_LIST_UPDATE = 'FORM_SUB_LIST_UPDATE', // mise à jour d'un élément de sous-liste de form
  FORM_VALUE_ERROR = 'FORM_VALUE_ERROR', // a minima une erreur sur les valeurs d'un formulaire
  FORM_VALUE_CHECK_EDIT = 'FORM_VALUE_CHECK_EDIT', // déclenche la séquence de contrôle d'édition des mesures d'un formulaire
  PIVOT_DOUBLE = 'PIVOT_DOUBLE', // doubleclic sur une ligne de pivot
  PIVOT_HEADER_COLLAPSE = 'PIVOT_HEADER_COLLAPSE', // collapse / expand sur un header de pivot, contrôle de l'état des parents
  FORM_MEASURES_CHECK = 'FORM_MEASURES_CHECK', // recalcul des mesures du formulaire sur modif de champ
  FORM_SET_DEFAULT = 'FORM_SET_DEFAULT', // alimentation des valeurs par défaut sur modif d'un form
  WIDGET_MUST_REFRESH = 'WIDGET_MUST_REFRESH', // retour de fonction connect, forcer le refresh de tous les widgets
  VISION_CONTEXT_LOADED = 'VISION_CONTEXT_LOADED', // le contexte de vision est chargé
  TAB_IS_ON = 'TAB_IS_ON', // on a un TAB, l'init est fini... Pour synchro des multi-displays
  WIDGET_CONFIG_UPDATE = 'WIDGET_CONFIG_UPDATE', // mise à jour de la conf d'un widget, pour activation button save / cancel sur templating
  GLOBAL_FILTER_UPDATE = 'GLOBAL_FILTER_UPDATE', // modif sur le filtre global data = filters du global
  TIMELINE_SELECT_FIELD = 'TIMELINE_SELECT_FIELD', // afficher ou pas un champ du timeline
  LOADING_EVENT = 'LOADING_EVENT', // événement sur chargement des données
  ALTER_VISION = 'ALTER_VISION', // modification dans la vue vision [visionVO, opération CUD]
  APPLY_SCENARIO = 'APPLY_SCENARIO', // choix d'un scenario pour le widget
  APPLY_GLOBAL_SCENARIO = 'APPLY_GLOBAL_SCENARIO', // choix d'un scenario global
  TILE_RENDERER_UPDATED = 'TILE_RENDERER_UPDATED', // mise à jour du rendu des tiles @data = wco du tile
  GLOBAL_SCENAR_UPDATE = 'GLOBAL_SCENAR_UPDATE', // modif du scenar global
  DATALOAD_READY = 'DATALOAD_READY', // sur WidgetDataService, signale que le pool de données level#scen est chargé et synchronisé param = Dataload
  FIRE_TRIGGER = 'FIRE_TRIGGER', // déclenchement d'un trigger sur un FEI data = TriggerData
  MASS_DELETE_REQUEST = 'MASS_DELETE_REQUEST', // demande de suppression en masse
  WIDGET_CONNECT_CALL = 'WIDGET_CONNECT_CALL', // appel connect depuis un bouton de la barre du widget data = connectVO
  WIDGET_MUST_FORGET = 'WIDGET_MUST_FORGET', //passage des statuts à INIT
  CLONE_WIDGET_REQUEST = 'CLONE_WIDGET_REQUEST', // demande de clonage de widget data = GridsterWidget
  CUSTOM_SORT = 'CUSTOM_SORT',
  UPDATE_DOMAIN = 'UPDATE_DOMAIN',
  UPDATE_BU = 'UPDATE_BU',
  COMPOSITE_RELOAD = 'COMPOSITE_RELOAD', // forcer le rechargement
  SHOWPOP = 'SHOWPOP',
  SHOWHEADERPOP = 'SHOWHEADERPOP',
  EDIT_PASSWORD = 'EDIT_PASSWORD', // édition du mdp du user dans DOM
  TIMELINE_REFRESH = 'TIMELINE_REFRESH',  // demande de refresh des items de la timeline
  UNSELECT = 'UNSELECT', // déselection forcée pour un form
  PROGRAMMATIC_FEED = 'PROGRAMMATIC_FEED', // comme doubleclic sur une ligne de pivot, porte un FDS

  COMPUTE_COUNT = 'COMPUTE_COUNT', // collecte du count pour un widget, dessin de la pagination
  COMPUTE_GET = 'COMPUTE_GET', // get d'une page sur compute
  COMPUTE_FAST_SYNC = 'COMPUTE_FAST_SYNC', // sur retour de datacommit, synchro immédiate des BLVs des grids remote pour éviter les pertes de sync sur numRev
  COMPUTE_REBUILD = 'COMPUTE_REBUILD', // besoin de reconstruire pour un widget (modif filtre, modif sort, modif structure)
  COMPUTE_UPDATE = 'COMPUTE_UPDATE', // refresh compute déclenchée par le backend
  COMPUTE_GET_RESULT = 'COMPUTE_GET_RESULT', // retour de get pour un widget
  PDF_PRINT_REQUEST = 'PDF_PRINT_REQUEST', // demande d'export de la vue en cours en PDF
  MESSAGE_UPDATE = 'MESSAGE_UPDATE', // mise à jour d'un message dans un form
  REMOTE_MESSAGE_UPDATE = 'REMOTE_MESSAGE_UPDATE', // mise à jour d'un message depuis le socketMessageEngine
  WIDGET_STATE = 'WIDGET_STATE', // dispatch sur modif d'un formulaire (donne son état modif / pas modif)
  VERBOSE = 'VERBOSE', // mode verbeux
  DELETE_WORKCOM_MESSAGE = 'DELETE_WORKCOM_MESSAGE', // suppression d'un message de workcom
  EDIT_WORKCOM_MESSAGE = 'EDIT_WORKCOM_MESSAGE', // maj de mon message
  GLOBAL_FILTER_CLEAR = 'GLOBAL_FILTER_CLEAR', // rincer les filtres si pas de filtre global
  GLOBAL_FILTER_INJECT = 'GLOBAL_FILTER_INJECT' // injection du filtre global dans la barre de menu
}

/** Constantes de portée de contexte */
export enum ALLKEY_COMMAND_METHOD {
  VISION_GENERATE_LINES = 'generateLines',
  VISION_GENERATE_NEW_LINES = 'generateNewLines',
  VISION_DELETE_LINES = 'deleteLines',
  VISION_DELETE_VALUES = 'deleteValues',
  VISION_CARTESIAN = 'cartesian',
}

/** Constante pour les unités de temps */
export enum TIME_UNIT {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  UNDEFINED = 'UNDEFINED',
}

/** constantes de tracking */
export enum TRACK_KEY {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  NAVIGATE = 'NAVIGATE',
}

/** Types de features dynamiques */
export enum FEATURE_KIND {
  VISION = 'VISION',
  VISION_STEP = 'VISION_STEP',
  VISION_STEP_PERIMETER = 'VISION_STEP_PERIMETER',
  TAB = 'TAB',
}

/**
 * Périmètre d'une feature
 */
export enum FEATURE_PERIMETER {
  WIZ = 'WIZ', /** Feature au périmètre wiz */
  DOM = 'DOM', /** Feature au périmètre dom */
  BU = 'BU', /** Feature au périmètre bu */
  APP_CONF = 'APP_CONF', /** Feature au périmètre configuration de l'application pour la BU */
  APP = 'APP', /** Feature au périmètre wiz */
}

/** Types de widget par objet manipulé */
export enum WIDGET_GLOBAL_KIND {
  BASELINE = 'BASELINE',
  FREEDATA = 'FREEDATA',
  NONE = 'NONE'
}

/** Types de widget */
export enum WIDGET_KIND {
  GRID = 'GRID', // tableau unitaire, à plat
  PIVOT = 'PIVOT', // tableau croisé
  LIST = 'LIST',
  CHART = 'CHART',
  FORM = 'FORM', // formulaire de saisie
  INCEXC = 'INCEXC', // pivot pour la gestion des exclusions
  CALENDAR = 'CALENDAR', // scheduler
  TIMELINE = 'TIMELINE', // timeline,
  TILE = 'TILE', // tuile
  FD_GRID = 'FD_GRID', // grid de consultation des FDVs
  FD_FORM = 'FD_FORM', // formulaire de saisie des FDVs
  FD_CALENDAR = 'FD_CALENDAR', // scheduler pour les FDVs,
  GLOBAL_FILTER = 'GLOBAL_FILTER', // filtre global
  FREE_FORM = 'FREE_FORM', // formulaire de saisie libre
  FD_TIMELINE = 'FD_TIMELINE', // timeline pour les FDVs,
  FD_TILE = 'FD_TILE', // tuile pour les FDVs,
  GENERATOR = 'GENERATOR', // générateur de baselines
}

/** états des widgets */
export enum WIDGET_STATE {
  INIT = 1, // le widget possède un contexte
  FEI_SET = 2, // le widget possède aussi son FEI
  FEI_COMPUTED = 4, // le fei du widget est computed
  READY = 8, // le widget est prêt
  SELECTION_COMPLETE = 16, // on a appliqué le pool de sélection sur le widget
}

/** différents mode pour l'affichage en liste */
export enum LIST_WIDGET_MODE {
  TOP10 = 'TOP10', // 10 premiers
  TOP20 = 'TOP20', // 20 premiers
}

/** différents mode pour l'affichage en chart */
export enum CHART_WIDGET_MODE {
  PIE = 'Pie', // secteur
  BAR = 'Bar', // barres verticales
  BAR_H = 'HorizontalBar', // barres horizontales
  GAUGE = 'Gauge', // jauge
  CARD = 'NumberCard', // vignettes
  TREEMAP = 'Treemap', // treemap
  PIE_GRID = 'PieGrid',
  PIE_ADVANCED = 'PieAdvanced',
  LINE = 'Line',
  MULTI_LINE = 'MultiLine',
  BAR_V_GROUPED = 'BarVGrouped',
  BAR_V_STACKED = 'BarVStacked',
  BAR_H_STACKED = 'BarHStacked',
  BUBBLE = 'bubble',
  POLAR = 'Polar'
}

/** Constante pour les sources d'include exclude */
export enum INC_EXC_KIND {
  FD = 'FD', // freedata
  CHRO = 'CHRO', // chronocode
  FDV = 'FDV', // freedataValue
}



/** Préfixes pour le stockage en indexDB, par objet */
export enum DBINDEX_KIND {
  FEI = 'FEI', // Dataset
  FD = 'FD', // freedata
  CHRONO = 'CHRONO', // chronocode
}

/** Type de data tel que référencé dans les entityClass des EntityModifications */
export enum BASIC_ENTITY_TYPE {
  BASELINE = 1,
  BASELINE_VALUE = 2,
  FREEDATA = 4,
  CHRONOCODE = 8,
  BUSINESS_UNIT = 16,
  LANGUAGE = 32,
  COUNTRY = 64,
  FREEDATAVALUE = 128,
  PHYSICAL_TEMPLATE = 256,
  WORKCOM = 512,
}

/** constantes de comparateurs */
export enum COMPARATOR {
  INF = 'INF',
  INFEQUAL = 'INFEQUAL',
  EQUAL = 'EQUAL',
  NOTEQUAL = 'NOTEQUAL',
  SUPEQUAL = 'SUPEQUAL',
  SUP = 'SUP',
  BET = 'BET', // between
  EMPTY = 'EMPTY',
  NOTEMPTY = 'NOTEMPTY',
  STARTWITH = 'STARTWITH',
  CONTAINS = 'CONTAINS',
  USER = 'USER', // une prop FD=[] sur le user / role / profil
  USER_OR_NULL = 'USERN' // une prop FD=[] sur le user / role / profil
}

/** constantes des omdes pour process connect */
export enum PROCESS_MODE {
  SYNC = 'SYNC',
  ASYNC = 'ASYNC'
}

/** portée de recherche des EMs */
export enum EM_RANGE {
  EM_RANGE_USER = 'USER',
  EM_RANGE_BU = 'BU',
  EM_RANGE_VISION = 'VISION'
}


/** types d'entrées de contexte */
export enum CONTEXT_TYPE {
  USER = 'user',
  APP = 'app',
  TAB = 'tab',
  WIDGET = 'widget'
}

// Noms des widgets spécifiques
export enum CONTEXT_SPECIFIC_TYPE {
  MULTI_DISPLAY = 'MULTI_DISPLAY', // un multi-display
  MAIN_FILTER = 'MAIN_FILTER', // un mainFilter
}

// Noms des widgets spécifiques
export enum SYNC_ERROR {
  CREATE_ON_EXIST = 'CREATE_ON_EXIST', // je crée sur un code existant
  UPDATE_ON_DELETE = 'UPDATE_ON_DELETE', // je mets à jour un mort
  UPDATE_ON_UPDATE = 'UPDATE_ON_UPDATE', // je mets à jour un mis à jour
}

// paramètre pour tracer l'origine de l'action dans les méthodes des widgets
export enum WIDGET_ACTION_ORIGIN {
  INIT = 'INIT', // init / chgt de FEI
  CONFIGURE = 'CONFIGURE', // modif de la configuration, potentiellement n'importe quoi sauf le FEI (et donc le scenar)
  READY = 'READY', // le widget est prêt
  FILTERING = 'FILTERING', // modif de filtre
  GLOBAL_FILTERING = 'GLOBAL_FILTERING', // modif de filtre global
  SELECT = 'SELECT', // modif de sélection
  OUTER_SELECT = 'OUTER_SELECT', // modif du pool actif par un élément externe (master, globalFilter)
  REQUIRED_COMPUTED = 'REQUIRED_COMPUTED', // fin de calcul initial d'un fei requis pour mes calculs
  RECOMPUTE = 'RECOMPUTE', // recalcul, possible altération du pool de lignes (CreateDelete)
  GLOBAL_SCENARIO_UPDATE = 'GLOBAL_SCENARIO_UPDATE', // modif sur le scenario global,
  SORT = 'SORT', // un tri, c'est impactant pour la pagination en mode compute
  GET_PAGE = 'GET_PAGE' // chargement d'une page
}

// injection de propriétés dans une map des objets WizCompute, pour rendu IHM sans Override des VOs
export enum VISION_PROPERTY {
  LOADED = 'loaded', // boolean, a vision est complétement chargée (avec ses collections)
  ISCONFIGAPP = 'isConfigApp', // boolean, c'est une vision de conf 
  LABEL = 'labelVO', // TranslatableLabelVO du label
  DESCRIPTION = 'descriptionVO', // TranslatableLabelVO de la description
  DOMBU = 'domBu', // label dom / bu
  METRICS = 'metrics', // VisionStat pour les métriques
  RUN_MODE_ICON = 'runModeIcon',
  RUN_MODE_TOOLTIP = 'runModeTooltip'
}

/** Constantes de portée de contexte */
export enum CONTEXT_RANGE {
  CONTEXT_AKDOM = 'CONTEXT_AKDOM',
  CONTEXT_APP = 'CONTEXT_APP',
  CONTEXT_TAB = 'CONTEXT_TAB',
  CONTEXT_WIDGET = 'CONTEXT_WIDGET'
}

/** Constantes d'entrées de contexte */
export enum CONTEXT {
  LOG_TIME = 'LOG_TIME',
  TAB_SELECT = 'TAB_SELECT',
  LEFT_PANEL = 'LEFT_PANEL',
  MAIN_FILTER = 'MAIN_FILTER',
  RIGHT_PANEL = 'RIGHT_PANEL',
  MULTI_DISPLAY = 'MULTI_DISPLAY',
  SELECTED_ITEM = 'SELECTED_ITEM',
  TABS = 'TABS',
  WIDGET = 'WIDGET',
  ADD_NEW_ITEM = 'ADD_NEW_ITEM',
  DOMAIN = 'DOMAIN',
  BU = 'BU',
  VISION = 'VISION',
  LANGUAGE = 'LANGUAGE'
}

/** types de connexions possibles pour Cnx */
export enum CNX_KIND {
  BDD = 'BDD',
  API = 'API',
  AUTHAPI = 'AUTHAPI',
  FTP = 'FTP',
}

/** types de FTP */
export enum FTP_PROTOCOL_KIND {
  FTP = 'FTP',
  FTPS = 'FTPS',
  SFTP = 'SFTP'
}

/** types de Bases de données */
export enum BDD_KIND {
  ORACLE = 'ORACLE',
  MYSQL = 'MYSQL',
  POSTGRES = 'POSTGRES',
  ALLKEYME = 'ALLKEYME',
}

/** types Auth */
export enum AUTH_KIND {
  SAML = 'SAML',
  OPENID = 'OpenID',
  GOOGLE = 'Google',
  FACEBOOK = 'Facebook',
  BASIC_AUTH = 'Basic Auth'
}

/** types de params pour les APIs (emplacement, en fait) */
export enum API_PARAM_KIND {
  API_URL_PARAM_LOCATION = 'URL',
  API_HEADER_PARAM_LOCATION = 'HEADER',
  API_BODY_PARAM_LOCATION = 'BODY',
}

/** modes de rendu pour les timelines */
export enum TIMELINE_MODE {
  YEAR = 1,
  QUARTER = 2,
  MONTH = 4,
  DAY = 8,
}

/** objets connect */
export enum CNX_OBJECT {
  PROCESS = 'process',
  FLOW = 'flow',
  STEP = 'step',
  PROCEDURE = 'procedure'
}

/** destination pour les tables de travail */
export enum WORKING_TABLE_WAY {
  IN_WORKING_TABLE = 'IN',
  OUT_WORKING_TABLE = 'OUT',
  IN_OUT_WORKING_TABLE = "IN_OUT"
}


/** type SQL pour les colonnes des tables de travail */
export enum SQL_TYPE {
  SQL_TYPE_STR = 'STR',
  SQL_TYPE_INT = 'INT',
  SQL_TYPE_LONG = "LONG",
  SQL_TYPE_DECIMAL = 'DECIMAL',
  SQL_TYPE_BOOLEAN = 'BOOLEAN',
  SQL_TYPE_JSONB = "JSONB",
  SQL_TYPE_DATE = "DATE"
}

/** type de statuts de sortie pour les flux */
export enum EXIT_STATUS {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  MEDIUM = "MEDIUM"
}

/** sous-statuts de sortie pour les flux (medium) */
export enum EXIT_STATUS_CODE {
  NO_FILE = 'NO_FILE',
  NO_WRITE_FILE = 'NO_WRITE_FILE',
  BAD_RESULT = "BAD_RESULT",
  NO_DATA = "NO_DATA"
}

/** statuts finaux pour les flux (pour alimentation du next) */
export enum END_STATUS {
  END = 'END',
  FAIL = 'FAIL',
}

/** Liste des types de paramètres applicatifs pour les engines connect */
export enum ENGINE_KIND {
  STR = 'STR',
  LONG = 'LONG',
  BOOLEAN = 'BOOLEAN',
  TIMESTAMP = 'TIMESTAMP',
  SEQUENCE = 'SEQUENCE',
  FREEDATA = 'FREEDATA',
  FREEDATAVALUE = 'FREEDATAVALUE',
  CHRONOCODE = 'CHRONOCODE',
  VISION = 'VISION',
  FILTER = 'FILTER',
  FILE = 'FILE',
  PROCESS = 'PROCESS',
  FLOW = 'FLOW',
  BODY = 'BODY',
}


/** steps standards */
export enum PREDEFINE_KIND {
  API_TO_CTX = 'API_TO_CTX',
  FILE_TO_TABLE = 'FILE_TO_TABLE',
  TABLE_TO_FILE = 'TABLE_TO_FILE',
  CALL_STORED_PROCEDURE = 'CALL_STORED_PROCEDURE',
  CALL_STORED_FUNCTION = 'CALL_STORED_FUNCTION',
  BUCKET_MOVE_FILE = 'BUCKET_MOVE_FILE',
  FTP_GET_FILE = 'FTP_GET_FILE',
  FTP_MOVE_FILE = 'FTP_MOVE_FILE',
  FTP_PUT_FILE = 'FTP_PUT_FILE',
  SAS_INTEGRATION = 'SAS_INTEGRATION',
  CONTEXT_DATA_DECISION = 'CONTEXT_DATA_DECISION',
  LOG_WRITER = 'LOG_WRITER',
  LOG_SIPHON = 'LOG_SIPHON',
  BUCKET_CLEANER = 'BUCKET_CLEANER',
  TABLE_CLEANER = 'TABLE_CLEANER',
  TABLE_TO_API = 'TABLE_TO_API',
  API_TO_TABLE = 'API_TO_TABLE',
  FILE_EXISTS = 'FILE_EXISTS'
}

/** types de partitions pour les steps */
export enum PARTITION_KIND {
  PARTITION_FILE = 'PARTITION_FILE',
  PARTITION_AKME = 'PARTITION_AKME'
}

/** event pour les step.event */
export enum STEP_EVENT_KIND {
  BEFORE_STEP = 'BEFORE_STEP',
  AFTER_STEP = 'AFTER_STEP'
}

/** opérations pour les step.operation */
export enum ENGINE_OPERATION_KIND {
  ENGINE_READ = 'ENGINE_READ',
  ENGINE_PREPARE = 'ENGINE_PREPARE',
  ENGINE_WRITE = 'ENGINE_WRITE',
  ENGINE_REMOVE = 'ENGINE_REMOVE',
}

/** scénario pour les step.operation */
export enum ENGINE_OPERATION_SCEN_KIND {
  SCEN_FREEDATA = 'FREEDATA',
  SCEN_CHRONO = 'CHRONO',
  SCEN_VISION = 'VISION',
}

/** param SQL prédéfini (ou le chercher) */
export enum PREDEFINED_SQL_PARAM {
  PROCESS_DOMAIN = 'PROCESS_DOMAIN',
  PROCESS_BU = 'PROCESS_BU',
  PROCESS_VISION = 'PROCESS_VISION',
  PROCESS_UUID = 'PROCESS_UUID',
  ENGINE = 'ENGINE',
  CUSTOM = 'CUSTOM'
}

/** types de reader (step.reader) */
export enum READER_KIND {
  FILE = 'FILE',
  API = 'API',
  SQL = 'SQL',
  CMP = 'CMP' // reader compute
}

/** repeat conditionType (step.reader) */
export enum REPEAT_CONDITION_KIND {
  WHILE_NOT_NULL_OR_EMPTY = 'WHILE_NOT_NULL_OR_EMPTY',
  WHILE_NOT_EQUALS = 'WHILE_NOT_EQUALS'
}

/** types de writer (step.writer) */
export enum WRITER_KIND {
  FILE = 'FILE',
  SQL = 'SQL',
  FREEDATA = 'FREEDATA',
  BASELINE = 'BASELINE'
}

/** types de writer (step.writer) */
export enum PROCESSOR_WAY {
  IN = 'IN',
  OUT = 'OUT',
  VAR = 'VAR',
  CONST = 'CONST'
}

/** types donnée contexte pour step.processor */
export enum CONTEXT_DATA {
  ENGINE = 'ENGINE',
  PREDEFINED = 'PREDEFINED'
}

/** type pour les processors */
export enum PROCESSOR_TYPE {
  STR = 'STR',
  INT = 'INT',
  LONG = "LONG",
  DECIMAL = 'DECIMAL',
  BOOLEAN = 'BOOLEAN',
  OBJECT = "OBJECT",
  DATE = "DATE",
  MAP = "MAP"
}

export enum CONNECT_RETURN_ACTION {
  NONE = 'NONE',
  REFRESH = 'REFRESH',
  SYNC = 'SYNC',
  POP = 'POP_REFRESH',
}

/** operations les processors */
export enum PROC_OP_TYPE {
  CONCAT = 'CONCAT',
  // CONSTANT = 'CONSTANT',
  CONTEXT_DATA_PERSIST = "CONTEXT_DATA_PERSIST",
  // CONTEXT_VARIABLE = 'CONTEXT_VARIABLE',
  COPY = 'COPY',
  DATESTR = "DATESTR",
  DECODE = "DECODE",
  DECODE_FDARGVAL = "DECODE_FDARGVAL",
  FDARGVAL = "FDARGVAL",
  FDVAL = "FDVAL",
  // INIT_CONST_VARIABLE = "INIT_CONST_VARIABLE",
  // INIT_CONTEXT_VARIABLE = "INIT_CONTEXT_VARIABLE",
  // INIT_OUT_ID_FIELD_VARIABLE = "INIT_OUT_ID_FIELD_VARIABLE",
  // OUT_FIELD_VARIABLE = "OUT_FIELD_VARIABLE",
  // OUT_ID_FIELD_VARIABLE = "OUT_ID_FIELD_VARIABLE",
  REPLACE = "REPLACE",
  IFNULLOREMPTY = "IFNULLOREMPTY",
  ROW_LOOP = "ROW_LOOP",
  ROW_PERSIST = "ROW_PERSIST",
  ROW_SELECT = "ROW_SELECT",
  // ROW_FIELD_VARIABLE = "ROW_FIELD_VARIABLE",
  SPLIT = "SPLIT",
  // VARIABLE = "VARIABLE"
}

/** type de champ à alimenter pour les logs */
export enum LOG_KEY_KIND {
  KEY = 'KEY',
  FILTERKEY = 'FILTERKEY',
  VALUE = 'VALUE',
  CONSTANT = 'CONSTANT', // injection d'une constante dans une mesure
  CRITERIA = 'CRITERIA'
}

/** type de champ spéciaux pour les mapping filte-table */
export enum MAPPING_SPECIAL_KIND {
  ROW_INDEX = 'ROW_INDEX',
  ROW = 'ROW',
  CONSTANT = 'CONSTANT',
  ERROR = 'ERROR'
}

/** formats pour les APIs */
export enum API_FORMAT {
  JSON = 'JSON',
  XML = 'XML',
  RAW = 'RAW'
}

/** constantes de type de navigation par page */
export enum PAGE_EVENT_KIND {
  ABS = 'ABS', // absolu
  REL = 'REL', // relatif
}

/** symboles de type de navigation par page */
export enum PAGE_EVENT_SYMBOL {
  FIRST = '<<',
  BACK = '<',
  NEXT = '>',
  LAST = '>>'
} 

/** formats de documents autorisés pour les appels IA */
export enum DOCUMENT_EXT {
  KIND_PDF = "PDF",
  KIND_DOCX = "DOCX"
}

// type de PDF à générer
export enum PDF_PAGE_KIND {
  IMAGE = 'IMAGE',
  HTML = 'HTML',
}

// états workflow
export enum WORKFLOW_STATE {
  INIT = 'INIT',
  PENDING = 'PENDING',
  ASSIGN = 'ASSIGN',
  OK = 'OK',
  KO = 'KO',
  CLOSED = 'CLOSED'
}